module.exports = __webpack_public_path__ + "img/138.4ffddab1.jpg";